import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=b66e0c1e"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports